"use client";

import { Button } from "@kyan/ui";

import { ConnectWalletWrapper } from "#/components/ConnectWalletWrapper/ConnectWalletWrapper";
import { confirmTrade } from "#/utils/modals/confirmTrade";

import { PortfolioImpactAndGreeks } from "../../../OptionsTab/components/SelectedOption/components/PortfolioImpactAndGreeks/PortfolioImpactAndGreeks";
import { PortfolioImpact } from "../../../PerpsTab/components/PortfolioImpact/PortfolioImpact";
import { TradeConfirmationOptionInstrument } from "../TradeConfirmationOptionInstrument/TradeConfirmationOptionInstrument";
import { TradeConfirmationPerpInstrument } from "../TradeConfirmationPerpInstrument/TradeConfirmationPerpInstrument";
import { useLimitTradeButtonController } from "./LimitTradeButton.controller";

export interface LimitTradeButtonProps {
  isTradeConfirmation?: boolean;
  onSuccess?: () => void;
}

export const LimitTradeButton: React.FC<LimitTradeButtonProps> = ({
  isTradeConfirmation = false,
  onSuccess,
}) => {
  const {
    isPerps,
    isLoading,
    buttonLabel,
    isDisabled,
    isSecondaryButtonVisible,
    secondaryButtonLabel,
    showTradeConfirmation,
    handlePostOrder,
    handleSecondaryButtonClick,
  } = useLimitTradeButtonController(onSuccess);

  // if we move this logic into the controller, since we are using LimitTradeButton we will face circular dependency issues
  const handleClick = () => {
    if (showTradeConfirmation && !isTradeConfirmation) {
      confirmTrade({
        header: "Limit Order",
        children: (
          <div className="grid gap-4">
            {isPerps ? (
              <>
                <TradeConfirmationPerpInstrument />
                <PortfolioImpact />
              </>
            ) : (
              <>
                <TradeConfirmationOptionInstrument />
                <PortfolioImpactAndGreeks isTradeConfirmation />
              </>
            )}
          </div>
        ),

        tradeButton: ({ handleClose }) => (
          <LimitTradeButton isTradeConfirmation onSuccess={handleClose} />
        ),
      });
      return;
    }

    handlePostOrder();
  };

  return (
    <ConnectWalletWrapper>
      <Button
        size="lg"
        disabled={isDisabled}
        isLoading={isLoading}
        className="mt-2 w-full text-[15px] shadow-none"
        onClick={handleClick}
      >
        {buttonLabel}
      </Button>
      {isSecondaryButtonVisible && (
        <Button
          variant="link"
          className="mt-3 w-full"
          onClick={handleSecondaryButtonClick}
        >
          {secondaryButtonLabel}
        </Button>
      )}
    </ConnectWalletWrapper>
  );
};
